import { tokens } from "@blurb/codex-react";
import { createStyles } from "@mantine/core";

export const useRpiTableStyles = createStyles({
  table: {
    tableLayout: "fixed",
    width: "100%",
    borderCollapse: "collapse",
    backgroundColor: tokens.color.semantic.bg.surface,

    "& .ellipsis": {
      textOverflow: "ellipsis",
      whiteSpace: "nowrap",
      overflow: "hidden",
    },

    "& > thead > tr": {
      userSelect: "none",
      backgroundColor: tokens.color.semantic.bg.graySubtlerHover,

      "& > th": {
        position: "relative",
        textAlign: "left",
        userSelect: "none",
        fontFamily: tokens.font.family.sans,
        lineHeight: tokens.font.lineHeight.normal,
        "font-weight": tokens.font.weight.semibold,
        fontSize: tokens.font.size.sm,
        color: tokens.color.semantic.text.subtle,
        padding: `${tokens.spacing[3]} ${tokens.spacing[3]}`,

        "&:not(:last-child)": {
          borderRight: `1px solid ${tokens.color.semantic.border.faint}`,
        },

        "& > .resizer": {
          position: "absolute",
          top: 0,
          right: -4,
          width: 7,
          zIndex: 10,
          height: "100%",
          cursor: "col-resize",
          backgroundColor: "currentcolor",
          pointerEvents: "auto",
          opacity: 0,

          "&:hover, &:active": {
            backgroundColor: tokens.color.semantic.border.faint,
            opacity: 1,
          },
        },

        "&:last-of-type > .resizer": {
          right: 0,
          width: 3,
        },
      },
    },

    "& > tbody > tr": {
      borderBottom: `1px solid ${tokens.color.semantic.border.faint}`,

      "&:last-of-type": {
        borderBottom: "none",
      },

      "&[data-disabled]": {
        backgroundColor: tokens.color.semantic.bg.neutralDisabled,
        color: tokens.color.semantic.text.disabled,
      },

      "& > td": {
        fontFamily: tokens.font.family.sans,
        lineHeight: tokens.font.lineHeight.normal,
        "font-weight": tokens.font.weight.normal,
        fontSize: tokens.font.size.sm,
        color: tokens.color.semantic.text.bold,
        padding: `${tokens.spacing[3]} ${tokens.spacing[3]}`,
        textOverflow: "ellipsis",
        whiteSpace: "nowrap",
        overflow: "hidden",

        "&.subRow": {
          whiteSpace: "normal",
          textOverflow: "unset",
          overflowX: "auto",
        },
      },
    },
  },
});
